const product = {
  order_item_id: 'SIM-ITEM-001',
  asin: 'B0SIMULATE1',
  seller_sku: 'SIM-MSKU-001',
  local_sku: 'SIM-LOCAL-001',
  title: 'Simulation Treadmill M1-3',
  product_name: '模拟扶手跑步机 M1-3',
  quantity_ordered: 1,
  quantity_shipped: 1,
  item_price_amount: '219.99',
  currency: 'EUR',
  product_image_url:
    'https://image.distributetop.com/lingxing-erp/901242425378370048/20260714/4337ed6eaf1c43b3b163d24f056c9eaa.jpg',
};

const syncedOrder = {
  amazon_order_id: '999-0000000-0000001',
  sync_status: 'synced',
  sync_error_code: null,
  sync_error_message: null,
  last_synced_at: '2026-08-20T09:34:40Z',
  next_sync_at: null,
  order_status: 'Shipped',
  order_total_amount: '162.79',
  currency: 'EUR',
  purchase_date_utc: '2026-08-18T19:50:32Z',
  source_updated_at: '2026-08-20T09:30:00Z',
  fulfillment_channel: 'AFN',
  sales_channel: 'Amazon.it',
  is_business_order: false,
  is_prime: true,
  is_promotion: false,
  is_return_order: false,
  is_replacement_order: false,
  remark: null,
  earliest_ship_at: '2026-08-19T21:59:59Z',
  latest_ship_at: '2026-08-20T21:59:59Z',
  shipped_at: '2026-08-19T10:20:24Z',
  earliest_delivery_at: '2026-08-22T06:00:00Z',
  latest_delivery_at: '2026-08-24T20:00:00Z',
  shipping_service: 'Standard',
  buyer_address_available: false,
  items: [product],
};

const createMessage = content => ({
  content,
  sender: 'user',
  timestamp: '2026-08-20T08:38:00Z',
});

export const PLAYGROUND_SCENARIOS = [
  {
    id: 'invoice',
    title: '发票申请 · 完整订单',
    preview: 'Can you provide an invoice?',
    subject: 'Invoice request for order 999-0000000-0000001',
    contact: {
      name: 'Demo Customer',
      email: 'demo.customer@example.com',
    },
    initialMessages: [
      createMessage(
        'Can you provide an invoice for my order number 999-0000000-0000001? I need this to activate my warranty.'
      ),
    ],
    orders: [syncedOrder],
  },
  {
    id: 'delivery_missing',
    title: '物流查询 · 缺少收货预计',
    preview: 'When will my order arrive?',
    subject: 'Delivery date for order 999-0000000-0000002',
    contact: {
      name: 'Delivery Demo',
      email: 'delivery.demo@example.com',
    },
    initialMessages: [
      createMessage(
        'My order 999-0000000-0000002 has shipped. When should it arrive?'
      ),
    ],
    orders: [
      {
        ...syncedOrder,
        amazon_order_id: '999-0000000-0000002',
        earliest_delivery_at: null,
        latest_delivery_at: null,
      },
    ],
  },
  {
    id: 'syncing',
    title: '订单正在同步',
    preview: 'Please check my order status.',
    subject: 'Order status 999-0000000-0000003',
    contact: {
      name: 'Syncing Demo',
      email: 'syncing.demo@example.com',
    },
    initialMessages: [
      createMessage('Please check the status of order 999-0000000-0000003.'),
    ],
    orders: [
      {
        ...syncedOrder,
        amazon_order_id: '999-0000000-0000003',
        sync_status: 'pending',
        order_status: null,
        last_synced_at: null,
        next_sync_at: '2026-08-20T10:05:00Z',
        items: [],
      },
    ],
  },
  {
    id: 'sync_failed',
    title: '订单同步失败',
    preview: 'The order cannot be found.',
    subject: 'Order lookup 999-0000000-0000004',
    contact: {
      name: 'Failure Demo',
      email: 'failure.demo@example.com',
    },
    initialMessages: [
      createMessage('Can you find my Amazon order 999-0000000-0000004?'),
    ],
    orders: [
      {
        ...syncedOrder,
        amazon_order_id: '999-0000000-0000004',
        sync_status: 'failed',
        sync_error_code: 'SIMULATED_NOT_FOUND',
        sync_error_message: '模拟场景：领星暂未返回该订单。',
        order_status: null,
        last_synced_at: '2026-08-20T09:34:40Z',
        next_sync_at: '2026-08-20T10:34:40Z',
        items: [],
      },
    ],
  },
  {
    id: 'multiple_orders',
    title: '一个会话包含多个订单',
    preview: 'I have questions about two orders.',
    subject: 'Two order questions',
    contact: {
      name: 'Multiple Order Demo',
      email: 'multiple.orders@example.com',
    },
    initialMessages: [
      createMessage(
        'I need help with orders 999-0000000-0000005 and 999-0000000-0000006.'
      ),
    ],
    orders: [
      { ...syncedOrder, amazon_order_id: '999-0000000-0000005' },
      {
        ...syncedOrder,
        amazon_order_id: '999-0000000-0000006',
        order_status: 'Unshipped',
        shipped_at: null,
        earliest_delivery_at: null,
        latest_delivery_at: null,
      },
    ],
  },
  {
    id: 'blank_conversation',
    title: '空白对话 · 仅订单数据',
    preview: '无消息，已关联模拟领星订单',
    subject: '',
    contact: {
      name: '',
      email: '',
    },
    initialMessages: [],
    orders: [
      {
        ...syncedOrder,
        amazon_order_id: '999-0000000-0000007',
      },
    ],
  },
];

export const buildSimulationContext = scenario => {
  return {
    environment: 'captain_playground_simulation',
    channel: 'email',
    contact: scenario.contact,
    subject: scenario.subject,
    lingxing_orders: scenario.orders,
  };
};
